import React, { useState } from 'react';
// import { Input, AutoComplete, Button } from 'antd';

// function getRandomInt(max, min = 0) {
//   return Math.floor(Math.random() * (max - min + 1)) + min; // eslint-disable-line no-mixed-operators
// }

// const searchResult = query =>
//   new Array(getRandomInt(5))
//     .join('.')
//     .split('.')
//     .map((item, idx) => {
//       const category = `${query}${idx}`;
//       return {
//         value: category,
//         label: (
//           <div
//             style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//             }}
//           >
//             <span>
//               Found {query} on{' '}
//               <a
//                 href={`https://s.taobao.com/search?q=${query}`}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 {category}
//               </a>
//             </span>
//             <span>{getRandomInt(200, 100)} results</span>
//           </div>
//         ),
//       };
//     });

// const SearchBar = () => {
//   const [options, setOptions] = useState([]);

//   const handleSearch = value => {
//     setOptions(value ? searchResult(value) : []);
//   };

//   const onSelect = value => {
//     console.log('onSelect', value);
//   };

//   return (
//     <AutoComplete
//       style={{
//         width: 600,
//       }}
//       options={options}
//       onSelect={onSelect}
//       onSearch={handleSearch}
//     >
//       <Input.Search size="large" placeholder="input here" enterButton />
//     </AutoComplete>
//   );
// };


const SearchBar = () => {
  const [options, setOptions] = useState([]);


  return (
    <div className="w-full">
      {/* <input 
        className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-11/12 p-2 text-gray-700 leading-tight shadow focus:shadow-none focus:outline-none focus:bg-white focus:border-purple-600" 
        id="inline-full-name" 
        type="text" 
        value="Mahindra 475 DI"
        /> */}

      <div className="flex flex-wrap items-stretch">
        <input type="text" className="flex-shrink flex-grow flex-auto leading-normal w-px flex-1 border h-10 border-grey-light rounded rounded-r-none px-3 relative focus:border-r-none" placeholder="Try 'Mahindra 475 DI'" />
        <div className="flex -mr-px">
          <span className="flex items-center bg-purple-600 border border-l-0 border-purple-600 px-4 text-white rounded-r cursor-pointer hover:bg-purple-700">
            <svg className="fill-current w-5 h-5" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd"></path></svg>
          </span>
        </div>	
      </div>	
    </div>
  );
};




export default SearchBar;